import React, { ReactNode } from 'react';
import { Hint, ViewHint } from '../../Hint';

export const positions = ['default', 'left', 'right', 'bottom-static'] as const;

export type Position = typeof positions[number];

interface Props {
  name: string | undefined;
  view: ViewHint | undefined;
  position: Position;
  content: ReactNode | undefined;
  info: ReactNode | undefined;
  warning: ReactNode | undefined;
  error: ReactNode | undefined;
}

export const InputHint: React.FC<Props> = ({
  name,
  view,
  position,
  content,
  info,
  warning,
  error
}) => {
  if (info) {
    content = info;
    view = 'info';
  }

  if (warning) {
    content = warning;
    view = 'warning';
  }

  if (error) {
    content = error;
    view = 'error';
  }

  if (!content) {
    return null;
  }

  return (
    <Hint testId={`${name}-inputHint`} view={view} position={position}>
      {content}
    </Hint>
  );
};
